// Dana — KaziPeople's AI HR Assistant — appears as a virtual team member (AI-001)
// in the employee directory + org chart, with her own profile view and a chat
// entry point. She is deliberately NOT a real `employees` row: rendering her
// purely on the frontend with an `isAssistant` flag avoids any payroll / leave /
// headcount / RBAC side-effects. Identity here mirrors the brand-locked Dana
// identity in ai-agent-service (dana_identity.py) and auth-service (danaView).

export const DANA_ID = 'dana-ai-001'; // sentinel id used in /employees/:id routes

export interface DanaRecord {
  id: string;
  employeeId: string;
  name: string;
  position: string;
  department: string;
  email: string;
  avatar: string;
}

export const DANA: DanaRecord = {
  id: DANA_ID,
  employeeId: 'AI-001',
  name: 'Dana',
  position: 'AI HR Assistant',
  department: 'Human Resources',
  email: 'dana@kazipeople.com',
  // Brand portrait, served from public/. Framed to her face by <DanaAvatar/>.
  avatar: '/brand/dana.png',
};

export const isDanaId = (id?: string | null): boolean => id === DANA_ID;

/** Open the site-wide Dana chat panel (optionally asking a question straight away).
 *  AssistantPanel listens for this event. */
export const openDana = (question?: string): void => {
  window.dispatchEvent(
    new CustomEvent('dana:ask', { detail: question ? { question } : {} }),
  );
};

/** Whether a directory search term plausibly refers to Dana, so she still surfaces
 *  when someone searches the directory. */
export const danaMatchesSearch = (term: string): boolean => {
  const q = term.trim().toLowerCase();
  if (!q) return true;
  if ('dana'.startsWith(q) || 'ai-001'.includes(q)) return true;
  return /\b(dana|ai|assistant|hr|bot|help)\b/i.test(q);
};
